import { render, staticRenderFns } from "./OpportunityReport.vue?vue&type=template&id=6e6428be"
import script from "./OpportunityReport.vue?vue&type=script&lang=js"
export * from "./OpportunityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports